<div class="ne-color" data-test-color-button="{hex}" style="background-color: {hex}">
  {#if isSelected}
    <HeartIcon />
  {/if}
</div>

<style>
  .ne-color {
    width: 100%;
    height: 100%;
    min-height: 64px;
    min-width: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .ne-color :global(path) {
    fill: #fff;
  }
</style>

<script>
  import HeartIcon from './HeartIcon.html';
  export let hex;
  export let isSelected;
</script>
